<template>
  <d-form @submit.prevent="save" :validated="hasErrors">
    <d-form-row>

      <!-- Nome -->
      <d-col md="8" class="form-group">
        <label for="name">Nome</label>
        <d-form-input
          :state="hasErrorFiled('name')"
          type="text"
          id="name"
          placeholder="Nome"
          v-model="model.name"
          @change="setContact('name')"
        />
        <d-form-invalid-feedback>Nome é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Data Inicio -->
      <d-col md="2" class="form-group">
        <label for="feInputDataInicio">Cliente desde</label>
        <datepicker :model.sync="model.started_at"/>
      </d-col>

      <!-- Pessoa -->
      <d-col md="2" class="form-group d-none d-md-block">
        <label>Pessoa Jurídica</label>
        <d-checkbox toggle @change="togglePersonType()" :checked="personType" class="custom-toggle-sm">Sim</d-checkbox>
      </d-col>

    </d-form-row>

    <d-form-row>
      <!-- Pessoa -->
      <d-col cols="3" md="2" class="form-group d-block d-md-none">
        <label>Pessoa Jurídica</label>
        <d-checkbox toggle @change="togglePersonType()" :checked="personType" class="custom-toggle-sm">Sim</d-checkbox>
      </d-col>

      <template v-if="model.type == 'corporate'">
        <!-- CNPJ -->
        <d-col cols="9" md="3" class="form-group">
          <label for="feCNPJ">CNPJ</label>
          <masked-input
            type="text"
            class="text-left form-control"
            id="feCNPJ"
            placeholder="00.000.000/0000-00"
            :mask="[
              /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.',
              /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '.',
              /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '/',
              /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, /[A-Za-z0-9]/, '-',
              /\d/, /\d/
            ]"
            :guide="false"
            v-model="model.document"
            @input="uppercaseInput('document')"
          ></masked-input>
        </d-col>
        <!-- Inscrição Estadual -->
        <d-col md="3" class="form-group">
          <label for="feInscricaoEstadual">Inscrição Estadual</label>
          <d-form-input
            type="text"
            v-model="model.state_registration"
            id="feInscricaoEstadual"
            placeholder="Inscrição Estadual"
          />
        </d-col>
      </template>
      <template v-if="model.type == 'individual'">
        <d-col cols="12" md="3" class="form-group">
          <d-form-row>
            <!-- CPF -->
            <d-col class="form-group">
              <label for="feCPF">CPF</label>
              <masked-input
                type="text"
                class="text-left form-control"
                id="feCPF"
                placeholder="000.000.000-00"
                :mask="[/\d/, /\d/, /\d/,'.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]"
                :guide="false"
                @change="setContact('document')"
                v-model="model.document"
              ></masked-input>
              <d-form-invalid-feedback>CPF é obrigatório</d-form-invalid-feedback>
            </d-col>
          </d-form-row>
        </d-col>
      </template>

      <!-- Email -->
      <d-col class="form-group">
        <label for="feEmail">E-mail</label>
        <d-form-input
          type="email"
          v-model="model.email"
          id="feEmail"
          placeholder="E-mail"
          @change="setContact('email')"
        />
        <d-form-invalid-feedback>E-mail é obrigatório</d-form-invalid-feedback>
      </d-col>

      <!-- Telefone  Whatsapp-->
      <d-col class="form-group">
        <label for="feTelefoneWhatsapp" v-if="model.type == 'corporate'">Telefone Empresa</label>
        <label for="feTelefoneWhatsapp" v-else>Telefone Whatsapp</label>
        <input-phone
          id="feTelefoneWhatsapp"
          placeholder="Telefone"
          :model.sync="model.phone"
          @change="setContact('phone')"
          :state="hasErrorFiled('phone')"
        ></input-phone>
        <d-form-invalid-feedback>Telefone é obrigatório</d-form-invalid-feedback>
      </d-col>

    </d-form-row>

    <d-form-row class="justify-content-between">
      <!-- Seller -->
      <d-col md="2" class="form-group" v-if="isAdmin">
        <label>Vendedor</label>
        <select-seller :model.sync="model.created_by" ></select-seller>
      </d-col>
    </d-form-row>

    <d-form-row>
      <addresses :customer.sync="model" :addresses.sync="model.addresses" ref="address"/>
    </d-form-row>

    <project-form :projects="model.projects" v-if="model.projects.length && this.showProject" ref="project"/>

    <d-form-row>
      <!-- Anotações -->
      <d-col md="12" class="form-group">
        <label for="feDescription">Anotações</label>
        <textarea id="feDescription" v-model="model.comment" rows="5" class="form-control"></textarea>
      </d-col>
    </d-form-row>

  </d-form>

</template>

<script>
import { mapActions } from 'vuex';
import mixin from '_common/mixins/ValidateForm';
import Events from '_utils/events';
import Loader from '_shared/Loader.vue';
import Datepicker from '_shared/Datepicker.vue';
import InputPhone from '_shared/InputPhone.vue';
import MaskedInput from 'vue-text-mask';
import SelectSeller from '_shared/SelectSeller.vue';
import CustomerService from '_services/rest/modules/customer';
import InputGeneralRegister from '_shared/InputGeneralRegister.vue';
import { capitalize, getDateISO, cloneDeep } from '_utils';
import Addresses from './Addresses.vue';
import ContacForm from './ContactForm.vue';
import ProjectForm from './ProjectForm.vue';
import { MODEL, _LOAD_MODEL_, _SAVE_CUSTOMER_SUCCESS_ } from './CustomerModel';

export default {
  name: 'customer-form',
  mixins: [mixin],
  props: {
    showProject: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    Loader,
    Addresses,
    ContacForm,
    Datepicker,
    InputPhone,
    MaskedInput,
    ProjectForm,
    SelectSeller,
    InputGeneralRegister,
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      loading: false,
      errors: {
        name: { required: false },
        phone: { required: false },
      },
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    personType() {
      if (this.model.type === 'individual') {
        return false;
      }
      return true;
    },
  },
  methods: {
    ...mapActions([
      'checkAdmin',
      'activeAlert',
    ]),
    capitalizeInput(field) {
      this.model[field] = capitalize(this.model[field]);
    },
    uppercaseInput(field) {
	    const value = this.model[field];
	    this.model[field] = value ? value.toUpperCase() : value;
    },
    capitalizeContact() {
      this.model.contacts[0].name = capitalize(this.model.contacts[0].name);
    },
    checkContact() {
      Object.keys(this.model.contacts[0]).forEach(attr => {
        if (this.model.contacts[0][attr] === '') {
          this.setContact(attr);
        }
        this.model.contacts[0].customer_id = this.model.id;
      });
    },
    saveCustomer() {
      CustomerService.save(this.model)
        .then(response => {
          this.success(response);
        })
        .catch(error => {
          this.toggleLoading();
          this.activeAlert({ message: `${error.message} <br/> ${error.data}`, theme: 'danger' });
        });
    },
    save() {
      // const validAddress = this.$refs.address.checkAddressForm();
      // const validProject = this.showProject ? this.$refs.project.checkProjectForm() : true;
      if (this.checkForm()) {
        this.toggleLoading();
        this.checkContact();
        const date = new Date(this.model.started_at);
        this.model.started_at = getDateISO(date);
        return this.saveCustomer();
      }
      return null;
    },
    setContact(type = 'phone') {
      if (type === 'name') {
        this.capitalizeInput(type);
      }
      if (this.model.type === 'individual') {
        this.model.contacts[0][type] = this.model[type];
      }
    },
    success(customerSaved) {
      this.toggleLoading();
      this.activeAlert({ message: 'Cliente salvo com sucesso', theme: 'success' });
      Events.$emit(_SAVE_CUSTOMER_SUCCESS_, customerSaved);
    },
    toggleLoading() {
      this.loading = !this.loading;
      Events.$emit('loading', this.loading);
    },
    togglePersonType() {
      if (this.model.type === 'individual') {
        this.model.type = 'corporate';
        return;
      }
      this.model.type = 'individual';
    },
    updateTabs() {
      setTimeout(() => {
        this.$refs.tabs.updateTabs();
      }, 10);
    },
    validRG() {
      if (this.submitted) {
        const rg = this.model.contacts[0].general_register;
        this.errors.general_register.required = (rg === null || rg.split(' SSP/')[0] === '');
        if (this.errors.general_register.required) {
          return 'invalid';
        }
        return 'valid';
      }
      return null;
    },
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, newValue => {
      this.model = { ...newValue };
    });
    this.checkAdmin();
  },
};
</script>

<style lang="scss" scoped>
.tab-pane {
  border: 1px solid #e1e5eb;
  border-top: 0;
}
</style>
